import React, { createContext, useContext, useEffect, useState } from "react";

export type Club = {
  id: number;
  display_name: string;
} | null;

type ClubContextType = {
  club: Club;
  clubId: number | null;
  setClub: (club: Club) => void;
  clearClub: () => void;
};

const ClubContext = createContext<ClubContextType | undefined>(undefined);
const STORAGE_KEY = "selectedClub";

export const ClubProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [club, setClubState] = useState<Club>(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as Club) : null;
    } catch {
      return null;
    }
  });

  // persist
  useEffect(() => {
    if (club) localStorage.setItem(STORAGE_KEY, JSON.stringify(club));
    else localStorage.removeItem(STORAGE_KEY);
  }, [club]);

  return (
    <ClubContext.Provider
      value={{
        club,
        clubId: club?.id ?? null,
        setClub: setClubState,
        clearClub: () => setClubState(null),
      }}
    >
      {children}
    </ClubContext.Provider>
  );
};

export const useClub = () => {
  const ctx = useContext(ClubContext);
  if (!ctx) throw new Error("useClub must be used inside ClubProvider");
  return ctx;
};
